import { Component, OnInit } from '@angular/core';
// import { AuthService } from '../_services/auth.service';
import { TokenStorageService } from '../_helpers/token-storage.service';
import { Router } from '@angular/router'
import { NotificationService } from '../_helpers/notification.service';
import { NgModule } from '@angular/core';
import { LoginService } from './login.service';
import { AppSettings } from '../_helpers/app.settings';
import { HttpService } from '../shared/http.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  form: any = {
    username: null,
    password: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  constructor(
    // private authService: AuthService,
    private router: Router, public notification:NotificationService,
    public loginService: LoginService,
    public tokenStorage: TokenStorageService,
    private http: HttpService
    ) {



   }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.router.navigate([AppSettings.DEFAULT_ROUTE]);
    }
  }

  onSubmit(): void {
    console.log("submit")
    let data = { 
      username: this.form.username,
      password: btoa(this.form.password) 
    };

    this.loginService.login({
      data: data,
      skipToken: true,
      success: (response: any) => {
        if(response) {
          const data = response;
          this.tokenStorage.saveToken(data.accessToken);
          this.tokenStorage.saveUserRole(data.userRole);
          this.tokenStorage.saveUsername(data.username);
          if(this.http.savedRoute) {
            this.router.navigate([this.http.savedRoute]);
            this.http.clearSavedRoute();
          } else {
            this.router.navigate([AppSettings.DEFAULT_ROUTE]);
          }
        }
      },
      error: (error: any) => {
        this.notification.showError(error.errorMessage);
        this.errorMessage = error.errorMessage;
      }
    });
  }

}
